export const WE_SPIN_ONBOARDING_CLOSED_COOKIE = 'WeSpinOnboardingClosed';
export const WE_SPIN_ONBOARDING_DISABLED_COOKIE = 'WeSpinOnboardingDisabled';
